(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.enBe = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = {
    domain: '',
    menuToggle: {
      label: 'MENU'
    },
    logo: {
      href: '/'
    },
    mainBtn: [{
      text: 'CONTACT',
      link: '/contact'
    }, {
      text: 'LOGIN',
      link: ''
    }],
    loginLink: {
      text: 'LOGIN',
      src: ''
    },
    siteLinks: [{
      title: {
        text: 'PRODUCTS'
      },
      list: [{
        text: 'Expense',
        src: '/expense-management'
      }, {
        text: 'Invoice',
        src: '/invoice-management'
      }, {
        text: 'Travel Booking',
        src: '/travel-booking'
      }]
    }, {
      title: {
        text: 'ABOUT US'
      },
      list: [{
        text: 'SAP Integration',
        src: '/sap-integration'
      }, {
        text: 'Why Concur',
        src: '/why-concur'
      }]
    }, {
      title: {
        text: 'RESOURCES'
      },
      list: [{
        text: 'Privacy Policy',
        src: '/privacy-policy'
      }, {
        text: 'Expense Demo',
        src: '/self-guided-demo-expense',
        classes: 'call-out hidden-xs hidden-sm hidden-md'
      }, {
        text: 'Invoice Demo',
        src: '/self-guided-demo-invoice',
        classes: 'call-out hidden-xs hidden-sm hidden-md'
      }]
    }],
    supportLinks: [
    // {
    //   text: 'CONCUR BLOG',
    //   href: '/newsroom',
    // },
    {
      text: 'CONTACT',
      href: '/contact'
    }],
    mobileAppText: {
      text: 'GET CONCUR MOBILE APP'
    }
  };
});